import type { Transaction } from '@api/hooks/types/getTransactions';
import { TFunction } from 'i18next';
import { FXPayment, PAYMENT_TYPE } from 'types/operations';

import { getFXAdditionalDetailsCard } from './Cards/FXAdditionalDetailsConfig';
import { getFXPaymentDetails } from './Cards/FXPaymentDetailsConfig';
import { getPayerDetailsCard } from './Cards/PayerDetailsConfig';
import { getPaymentDetailsCard } from './Cards/PaymentDetailsConfig';
import { getSenderRecipientCard } from './Cards/SenderRecipientConfig';
import { getSEPAAdditionalDetailsCard } from './Cards/SepaAdditionalDetailsConfig';
import { getSwiftAdditionalDetailsCard } from './Cards/SwiftAdditionalDetailsConfig';
import type { CardConfig } from './types';

export const getSepaCards = (
	operation: Transaction,
	t: TFunction,
	hasAddressAligned?: boolean,
): CardConfig[] => [
	getPaymentDetailsCard(operation, t),
	getSenderRecipientCard(operation, t),
	getSEPAAdditionalDetailsCard(operation, t, hasAddressAligned),
	getPayerDetailsCard(operation, t),
];

export const getInternationalCards = (
	operation: Transaction,
	t: TFunction,
	hasAddressAligned?: boolean,
): CardConfig[] => [
	getPaymentDetailsCard(operation, t),
	getSenderRecipientCard(operation, t),
	getSwiftAdditionalDetailsCard(operation, t, hasAddressAligned),
];

export const getFXCards = (operation: FXPayment, t: TFunction): CardConfig[] => [
	getFXPaymentDetails(operation, t),
	getSenderRecipientCard(operation, t),
	getFXAdditionalDetailsCard(operation, t),
];

type GetCards = (operation: Transaction, t: TFunction) => CardConfig[];

const paymentCardsMapper: Partial<Record<PAYMENT_TYPE, GetCards>> = {
	[PAYMENT_TYPE.FX]: (operation, t) => getFXCards(operation as FXPayment, t),
	[PAYMENT_TYPE.INTERNATIONAL]: getInternationalCards,
	[PAYMENT_TYPE.DOMESTIC]: getSepaCards,
	[PAYMENT_TYPE.INTERNAL]: getSepaCards,
};

export const getPaymentDetailCards = (
	operation: Transaction,
	t: TFunction,
	hasAddressAligned?: boolean,
): CardConfig[] => {
	const getCards =
		paymentCardsMapper[operation.payment_type as PAYMENT_TYPE] ?? getSepaCards;

	return getCards(operation, t, hasAddressAligned);
};
